module.exports = __webpack_public_path__ + "img/3.cf48e042.png";